const getTitle = (): string => document.title;

export { getTitle };
